import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchHats = () => axios.get(`${API}/hats`).then((r) => r.data);

export const createBooking = (payload) =>
  axios.post(`${API}/bookings`, payload).then((r) => r.data);

export const createContact = (payload) =>
  axios.post(`${API}/contacts`, payload).then((r) => r.data);

export const catalogUrl = `${API}/catalog.pdf`;
